<template>
  <div
    class="labelDisplay"
    :class="{ 'moneyLabel': moneyLabel, 'last': last }"
  >
    <div
      v-if="!isNumber(data.value)"
      class="num"
    >
      {{ data.value }}
    </div>
    <div
      v-if="isNumber(data.value)"
      class="moneyValue"
    >
      <div class="symbol">
        {{ splitSymbol }}
      </div>
      <div class="value">
        {{ splitValue }}
      </div>
    </div>
    <div class="label">
      {{ data.label }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    },
    moneyLabel: {
      type: Boolean
    },
    last: {
      type: Boolean
    }
  },
  computed: {
    splitSymbol () {
      if (this.data.value && this.moneyLabel) {
        return '¥'
      }
      return '¥'
    },
    splitValue () {
      if (this.data.value && this.moneyLabel) {
        return this.data.value.split('¥')[1]
      }
      return '¥'
    }
  },
  methods: {
    isNumber (str) {
      return /¥/.test(str)
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin afterelement {
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: '';
    height: 100%;
    right: 5px;
    top: 0;
    width: 1px;
    background: rgba(0, 0, 0, 0.1);
  }
}
@mixin clearafterelement {
  &:after {
    display: none;
  }
}
.labelDisplay {
  .num,
  .moneyValue {
    font-size: 24px;
    color: black;
  }
  .num {
    @include afterelement();
  }
  .label {
    font-size: 14px;
  }
  .moneyValue {
    display: flex;
    align-items: flex-end;
    @include afterelement();

    .symbol {
      margin-right: 4px;
      font-size: 14px;
      position: relative;
      bottom: 4px;
    }
  }

  &.moneyLabel {
    .num {
      color: black;
    }
  }
  &.last {
    .num {
      @include clearafterelement();
    }
    .moneyValue {
      @include clearafterelement();
    }
  }
}
@media only screen and (max-width: 1600px) {
  .labelDisplay {
    .num,
    .moneyValue {
      font-size: 20px;
      color: black;
    }
    .label,
    .moneyLabel {
      font-size: 12px;
    }

    .moneyValue {
      .symbol {
        margin-right: 4px;
        font-size: 11px;
        position: relative;
        bottom: 4px;
      }
    }
  }
}
</style>
